import { react2angular } from 'react2angular';
import { AlarmEventList } from './AlarmEventList';

angular
  .module('webtip.module')
  .component('alarmEventList', react2angular(AlarmEventList, [
    'isActive',
    'onView',
  ], ['alarmEventService', 'alarmNotificationService']));